import { RefObject } from 'react';

interface FolderInputProps {
  inputRef: RefObject<HTMLInputElement | null>;
  onPick: (files: File[]) => void;
}

/**
 * A hidden input that opens the system folder dialog. Click it from inside a
 * click handler: browsers only open file dialogs in response to a user action.
 */
export const FolderInput = ({ inputRef, onPick }: FolderInputProps) => (
  <input
    ref={inputRef}
    type="file"
    // Browser-specific attributes for directory selection. Cast to any
    // because React's typings don't include the non-standard fields.
    /* eslint-disable @typescript-eslint/no-explicit-any */
    {...({
      webkitdirectory: '',
      directory: '',
    } as any)}
    /* eslint-enable @typescript-eslint/no-explicit-any */
    multiple
    hidden
    onChange={(e) => {
      const files = Array.from(e.target.files || []);
      // Clear so re-selecting the same folder still fires onChange.
      e.target.value = '';
      if (files.length > 0) onPick(files);
    }}
  />
);
